
export const WateredSprite = <ellipse cx="27.5" cy="23" rx="27.5" ry="13" fill="#754c24" />;
